import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'antd/lib';
import { Flex, TextComponent } from '@monorepo/react-components';

import styles from './dashboard-loader.module.scss';

const DashboardLoader: React.FC = () => {
  const { t } = useTranslation('affiliate');

  return (
    <Flex vertical className={styles.loaderContainer}>
      <TextComponent level={4} className={styles.loadingText}>
        {t('affiliatePortal.loading.dashboard')}
      </TextComponent>

      <Flex className={styles.loaderContent}>
        {/* Main content area skeleton */}
        <Flex vertical className={styles.mainContentLoader}>
          <Skeleton
            active
            paragraph={{ rows: 1 }}
            className={styles.statsLoader}
          />
          <Skeleton
            active
            paragraph={{ rows: 4 }}
            className={styles.chartLoader}
          />
          <Skeleton
            active
            paragraph={{ rows: 2 }}
            className={styles.linkLoader}
          />
          <Skeleton
            active
            paragraph={{ rows: 6 }}
            className={styles.tableLoader}
          />
        </Flex>

        {/* Sidebar skeleton */}
        <Flex vertical className={styles.sidebarLoader}>
          <Skeleton
            active
            paragraph={{ rows: 3 }}
            className={styles.cardLoader}
          />
          <Skeleton
            active
            paragraph={{ rows: 4 }}
            className={styles.cardLoader}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DashboardLoader;
